<template>
  <div
    class="bg-primary-500 pl-4 md:pl-7 pr-1 flex items-center text-white transition-all ease-in-out duration-250"
    :class="{
      'sticky top-0': isSticky,
    }"
  >
    <nuxt-link :to="{ name: 'home' }">
      <SpriteSymbol
        name="logo"
        alt="SV Group logo"
        class="h-7 aspect-[73/24]"
      />
      <h2 class="sr-only">SV Group</h2>
    </nuxt-link>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  isSticky: boolean
}>()
</script>
